import capitalize from 'lodash/capitalize.js';

export default {
    methods: {
        parseTitle(title) {
            if (this.section?.type === 'topic') {
                return title;
            }

            const hasTitle = !this.item.has_fallback_text;
            const optionalTitle = hasTitle ? `: ${title}` : '';
            const type = capitalize(this.section.type);
            const dateRange = this.dateRange ? ` (${this.dateRange})` : '';

            if (this.isBreak) {
                return `${type}${dateRange}${optionalTitle}`;
            }

            if (this.isWeek) {
                return `${type} ${this.section.week}${dateRange}${optionalTitle}`;
            }

            return title;
        },
    },
};
